// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__29f9k","bigColWidth":"Table_bigColWidth__210yH","biggerColWidth":"Table_biggerColWidth__yv4T6","row":"Table_row__8WGMA","col":"Table_col__5e60L"};